import React, { useEffect, useState } from 'react';
import pike from '../assets/fish/pike.png';
import trout from '../assets/fish/trout.png';
import largemouth from '../assets/fish/largemouth.png';
import smallmouth from '../assets/fish/smallmouth.png';
import bluegill from '../assets/fish/bluegill.png';
import flounder from '../assets/fish/flounder.png';
import stripedbass from '../assets/fish/stripedbass.png';
import bluefish from '../assets/fish/bluefish.png';
import snakehead from '../assets/fish/snakehead.png';
import laketrout from '../assets/fish/laketrout.png';
import catfish from '../assets/fish/catfish.png';
import carp from '../assets/fish/carp.png';
import rainbowtrout from '../assets/fish/rainbowtrout.png';
import browntrout from '../assets/fish/browntrout.png';
import brooktrout from '../assets/fish/brooktrout.png';
import tautog from '../assets/fish/tautog.png';
import mahimahi from '../assets/fish/mahimahi.png';
import salmon from '../assets/fish/salmon.png';
import blackseabass from '../assets/fish/blackseabass.png';
import tuna from '../assets/fish/tuna.png';
import shark from '../assets/fish/shark.png';
import walleye from '../assets/fish/walleye.png';
import yellowperch from '../assets/fish/yellowperch.png';
import weakfish from '../assets/fish/weakfish.png';
import chainpickerel from '../assets/fish/chainpickerel.png';
import swordfish from '../assets/fish/swordfish.png';
import muskie from '../assets/fish/muskie.png';
import americanshad from '../assets/fish/americanshad.png';
import arcticchar from '../assets/fish/arcticchar.png';
import crappie from '../assets/fish/crappie.png';
import bowfin from '../assets/fish/bowfin.png';
import longnosegar from '../assets/fish/longnosegar.png';
import alligatorgar from '../assets/fish/alligatorgar.png';
import porgy from '../assets/fish/porgy.png';
import blackdrum from '../assets/fish/blackdrum.png';
import cobia from '../assets/fish/cobia.png';
import wahoo from '../assets/fish/wahoo.png';
import bluemarlin from '../assets/fish/bluemarlin.png';
import bonefish from '../assets/fish/bonefish.png';
import permit from '../assets/fish/permit.png';
import tarpon from '../assets/fish/tarpon.png';
import snook from '../assets/fish/snook.png';
import redfish from '../assets/fish/redfish.png';
import barracuda from '../assets/fish/barracuda.png';
import jackcrevalle from '../assets/fish/jackcrevalle.png';
import mangrovesnapper from '../assets/fish/mangrovesnapper.png';
import whiteperch from '../assets/fish/whiteperch.png';
import fallfish from '../assets/fish/fallfish.png';
import rockbass from '../assets/fish/rockbass.png';
import channelcatfish from '../assets/fish/channelcatfish.png';
import landlockedsalmon from '../assets/fish/landlockedsalmon.png';
import splake from '../assets/fish/splake.png';
import tigertrout from '../assets/fish/tigertrout.png';
import pumpkinseed from '../assets/fish/pumpkinseed.png';
import warmouth from '../assets/fish/warmouth.png';
import whitecatfish from '../assets/fish/whitecatfish.png';
import floridabass from '../assets/fish/floridabass.png';
import winterflounder from '../assets/fish/winterflounder.png';
import northernkingfish from '../assets/fish/northernkingfish.png';
import searobin from '../assets/fish/searobin.png';
import oystertoadfish from '../assets/fish/oystertoadfish.png';
import americaneel from '../assets/fish/americaneel.png';
import spanishmackerel from '../assets/fish/spanishmackerel.png';
import bonito from '../assets/fish/bonito.png';
import littletunny from '../assets/fish/littletunny.png';
import pompano from '../assets/fish/pompano.png';
import sandbarshark from '../assets/fish/sandbarshark.png';
import kingmackerel from '../assets/fish/kingmackerel.png';
import yellowfintuna from '../assets/fish/yellowfintuna.png';
import bluefintuna from '../assets/fish/bluefintuna.png';
import bigeyetuna from '../assets/fish/bigeyetuna.png';
import threshershark from '../assets/fish/threshershark.png';
import makoshark from '../assets/fish/makoshark.png';
import tilefish from '../assets/fish/tilefish.png';
import whitemarlin from '../assets/fish/whitemarlin.png';
import sailfish from '../assets/fish/sailfish.png';
import opah from '../assets/fish/opah.png';
import spottedseatrout from '../assets/fish/spottedseatrout.png';
import ladyfish from '../assets/fish/ladyfish.png';
import lemonshark from '../assets/fish/lemonshark.png';
import stick from '../assets/fish/stick.png';
import boot from '../assets/fish/boot.png';
import plate from '../assets/fish/plate.png';
import bottle from '../assets/fish/bottle.png';
import roosterfish from '../assets/fish/roosterfish.png';
import yellowtail from '../assets/fish/yellowtail.png';
import calicobass from '../assets/fish/calicobass.png';
import californiahalibut from '../assets/fish/californiahalibut.png';
import lingcod from '../assets/fish/lingcod.png';
import cabezon from '../assets/fish/cabezon.png';
import giantseabass from '../assets/fish/giantseabass.png';
import stripedmarlin from '../assets/fish/stripedmarlin.png';
import corvina from '../assets/fish/corvina.png';
import sierra from '../assets/fish/sierra.png';
import PIXEL_SIZES from '../assets/fish/pixel/sizes.json';

// Bold neon-outline sticker art, each one its own dedicated render (never a crop pulled out
// of a shared multi-fish reference sheet — those were lower resolution and occasionally
// carried extraction artifacts). Every species below has its own art; anything else falls
// back to trout — no page should ever show the old hand-drawn or historical-engraving
// illustrations again.
const fishDetails = {
  pike: { label: 'Northern pike', src: pike },
  trout: { label: 'Trout', src: trout },
  largemouth: { label: 'Largemouth bass', src: largemouth },
  smallmouth: { label: 'Smallmouth bass', src: smallmouth },
  bluegill: { label: 'Bluegill', src: bluegill },
  flounder: { label: 'Flounder', src: flounder },
  stripedbass: { label: 'Striped bass', src: stripedbass },
  bluefish: { label: 'Bluefish', src: bluefish },
  snakehead: { label: 'Northern snakehead', src: snakehead },
  laketrout: { label: 'Lake trout', src: laketrout },
  catfish: { label: 'Catfish', src: catfish },
  carp: { label: 'Carp', src: carp },
  rainbowtrout: { label: 'Rainbow trout', src: rainbowtrout },
  browntrout: { label: 'Brown trout', src: browntrout },
  brooktrout: { label: 'Brook trout', src: brooktrout },
  tautog: { label: 'Tautog', src: tautog },
  mahimahi: { label: 'Mahi mahi', src: mahimahi },
  salmon: { label: 'Atlantic salmon', src: salmon },
  blackseabass: { label: 'Black sea bass', src: blackseabass },
  tuna: { label: 'Tuna', src: tuna },
  shark: { label: 'Shark', src: shark },
  walleye: { label: 'Walleye', src: walleye },
  yellowperch: { label: 'Yellow perch', src: yellowperch },
  weakfish: { label: 'Weakfish', src: weakfish },
  chainpickerel: { label: 'Chain pickerel', src: chainpickerel },
  swordfish: { label: 'Swordfish', src: swordfish },
  muskie: { label: 'Muskellunge', src: muskie },
  americanshad: { label: 'American shad', src: americanshad },
  arcticchar: { label: 'Arctic char', src: arcticchar },
  crappie: { label: 'Crappie', src: crappie },
  bowfin: { label: 'Bowfin', src: bowfin },
  longnosegar: { label: 'Longnose gar', src: longnosegar },
  alligatorgar: { label: 'Alligator gar', src: alligatorgar },
  porgy: { label: 'Porgy', src: porgy },
  blackdrum: { label: 'Black drum', src: blackdrum },
  cobia: { label: 'Cobia', src: cobia },
  wahoo: { label: 'Wahoo', src: wahoo },
  bluemarlin: { label: 'Blue marlin', src: bluemarlin },
  bonefish: { label: 'Bonefish', src: bonefish },
  permit: { label: 'Permit', src: permit },
  tarpon: { label: 'Tarpon', src: tarpon },
  snook: { label: 'Snook', src: snook },
  redfish: { label: 'Redfish', src: redfish },
  barracuda: { label: 'Barracuda', src: barracuda },
  jackcrevalle: { label: 'Jack crevalle', src: jackcrevalle },
  mangrovesnapper: { label: 'Mangrove snapper', src: mangrovesnapper },
  whiteperch: { label: 'White perch', src: whiteperch },
  fallfish: { label: 'Fallfish', src: fallfish },
  rockbass: { label: 'Rock bass', src: rockbass },
  channelcatfish: { label: 'Channel catfish', src: channelcatfish },
  landlockedsalmon: { label: 'Landlocked salmon', src: landlockedsalmon },
  splake: { label: 'Splake', src: splake },
  tigertrout: { label: 'Tiger trout', src: tigertrout },
  pumpkinseed: { label: 'Pumpkinseed', src: pumpkinseed },
  warmouth: { label: 'Warmouth', src: warmouth },
  whitecatfish: { label: 'White catfish', src: whitecatfish },
  floridabass: { label: 'Florida bass', src: floridabass },
  winterflounder: { label: 'Winter flounder', src: winterflounder },
  northernkingfish: { label: 'Northern kingfish', src: northernkingfish },
  searobin: { label: 'Sea robin', src: searobin },
  oystertoadfish: { label: 'Oyster toadfish', src: oystertoadfish },
  americaneel: { label: 'American eel', src: americaneel },
  spanishmackerel: { label: 'Spanish mackerel', src: spanishmackerel },
  bonito: { label: 'Bonito', src: bonito },
  littletunny: { label: 'False albacore', src: littletunny },
  pompano: { label: 'Pompano', src: pompano },
  sandbarshark: { label: 'Sandbar shark', src: sandbarshark },
  kingmackerel: { label: 'King mackerel', src: kingmackerel },
  yellowfintuna: { label: 'Yellowfin tuna', src: yellowfintuna },
  bluefintuna: { label: 'Bluefin tuna', src: bluefintuna },
  bigeyetuna: { label: 'Bigeye tuna', src: bigeyetuna },
  threshershark: { label: 'Thresher shark', src: threshershark },
  makoshark: { label: 'Mako shark', src: makoshark },
  tilefish: { label: 'Golden tilefish', src: tilefish },
  whitemarlin: { label: 'White marlin', src: whitemarlin },
  sailfish: { label: 'Sailfish', src: sailfish },
  opah: { label: 'Opah', src: opah },
  spottedseatrout: { label: 'Spotted seatrout', src: spottedseatrout },
  ladyfish: { label: 'Ladyfish', src: ladyfish },
  lemonshark: { label: 'Lemon shark', src: lemonshark },
  roosterfish: { label: 'Roosterfish', src: roosterfish },
  yellowtail: { label: 'Yellowtail', src: yellowtail },
  calicobass: { label: 'Calico bass', src: calicobass },
  californiahalibut: { label: 'California halibut', src: californiahalibut },
  lingcod: { label: 'Lingcod', src: lingcod },
  cabezon: { label: 'Cabezon', src: cabezon },
  giantseabass: { label: 'Giant sea bass', src: giantseabass },
  stripedmarlin: { label: 'Striped marlin', src: stripedmarlin },
  corvina: { label: 'Corvina', src: corvina },
  sierra: { label: 'Sierra mackerel', src: sierra },
  // Not a fish: the junk catch (see rollJunk in utils/gameSpecies.js).
  stick: { label: 'A stick', src: stick },
  boot: { label: 'An old boot', src: boot },
  plate: { label: 'A licence plate', src: plate },
  bottle: { label: 'A bottle with a note', src: bottle },
};

export const HERO_SPECIES = Object.keys(fishDetails);

// The in-game variant: every sticker again at the game world's art pixel (scripts/pixelFish.mjs
// writes them and the manifest) with a one-pixel keyline, #e3fb14 ring and outer keyline, drawn
// at a length that follows its species' typical size — 38 art pixels for the smallest panfish to
// 120 for a marlin, on one compressed log scale (lengthFor in the script), never past
// PIXEL_FISH_BOX. Drawn one file pixel to one art pixel (ART_PX painting units) it sits on the
// stage like the angler, so a bluegill held up beside him is under half his height and a marlin
// fills the reveal; the site keeps the stickers.
//
// The files are small enough that the build inlines every one — about 200 kB gzipped for the
// set — so they are kept out of the site's bundle: they load as a chunk of their own the first
// time a pixel variant is drawn, and the game calls preloadPixelFish() when it opens, so by the
// time a fish is landed the reveal draws at once. Their sizes are here from the start
// (sizes.json), so a box can be laid out before the art arrives.
// The largest any variant is drawn (a billfish's length, a deep fish's height).
export const PIXEL_FISH_BOX = { w: 120, h: 72 };

// The pixel variant's native size in art pixels, or null when the species has none.
export function pixelFishSize(species) {
  const size = PIXEL_SIZES[species];
  return size ? { w: size[0], h: size[1] } : null;
}

// A load that fails (a dropped connection, a deploy that replaced the chunk mid-visit) is not
// kept: the promise rejects for whoever asked, and the next call tries the chunk again.
let pixelFish = null;
let pixelLoad = null;
export function preloadPixelFish() {
  if (!pixelLoad) {
    pixelLoad = import('../assets/fish/pixel').then(
      (module) => { pixelFish = module.PIXEL_FISH; return pixelFish; },
      (error) => { pixelLoad = null; throw error; },
    );
  }
  return pixelLoad;
}

// A transparent pixel, so a pixel variant's box stays empty (not a broken image) for the moment
// before its chunk arrives.
const BLANK = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

// variant="pixel" draws the pixel variant (pixelated, data-variant="pixel", with its native
// size as width/height so the box keeps its shape before it loads); a species without one, or a
// fish drawn when the pixel chunk failed to load, gets the sticker (data-variant="sticker").
// Without a variant nothing changes.
export default function FishIllustration({ species, className = '', style, variant }) {
  const fish = fishDetails[species] || fishDetails.trout;
  const size = variant === 'pixel' ? PIXEL_SIZES[species] : null;
  const [art, setArt] = useState(pixelFish);
  // The chunk failed to arrive: this one draws the sticker (the next fish mounted tries again).
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!size || art || failed) return undefined;
    let live = true;
    preloadPixelFish().then(
      (loaded) => { if (live) setArt(loaded); },
      () => { if (live) setFailed(true); },
    );
    return () => { live = false; };
  }, [size, art, failed]);
  if (variant === 'pixel') {
    if (size && !failed) {
      const src = art?.[species]?.src;
      return <img className={`fish-illustration is-pixel ${className}`} data-species={species} data-variant="pixel" data-loading={src ? undefined : 'yes'} src={src || BLANK} alt={fish.label} width={size[0]} height={size[1]} style={{ imageRendering: 'pixelated', ...style }} />;
    }
    return <img className={`fish-illustration ${className}`} data-species={species} data-variant="sticker" src={fish.src} alt={fish.label} style={style} />;
  }
  return <img className={`fish-illustration ${className}`} data-species={species} src={fish.src} alt={fish.label} style={style} />;
}
